import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	assetsType: {
		id: 'search-page.filters.names.assets-type',
		defaultMessage: 'Object type',
		description: 'Label for filtering by assets type',
	},
	assetsFilterAssetsTypePlaceholder: {
		id: 'search-page.assets.filter.assets-type.placeholder',
		defaultMessage: 'Find object types',
		description: 'Placeholder for assets type filter search input',
	},
	assetsFilterLabelSelected: {
		id: 'search-page.assets.filter.assets-type.label.selected',
		defaultMessage: 'Selected',
		description: 'Label for selected object types',
	},
	assetsFilterLabelUnselected: {
		id: 'search-page.assets.filter.assets-type.label.unselected',
		defaultMessage: 'Suggested',
		description: 'Label for suggested object types',
	},
	assetsIconLabel: {
		id: 'search-page.assets.filter.assets-type.icon.label',
		defaultMessage: 'Object type filter',
		description:
			'An icon that is displayed when there are no products selected to signify that the filter is associated with Assets',
	},
});
